import { forwardRef, type Ref, type SVGProps } from "react";
const IconHeatOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M15 20.174V6.998a1 1 0 0 0-2 0v13.176a2.999 2.999 0 1 0 3.957 3.335A3 3 0 0 0 15 20.174" />
    <path
      fillRule="evenodd"
      d="M19 6.998v11.107a6.996 6.996 0 0 1-.067 9.862 7 7 0 0 1-9.866 0A6.996 6.996 0 0 1 9 18.105V6.998A5 5 0 0 1 14 2a5 5 0 0 1 5 4.998m-9.61 17.93a5 5 0 0 0 9.22 0 5 5 0 0 0-1.04-5.434l-.57-.58V6.999a3 3 0 0 0-6 0v11.917l-.57.58a5 5 0 0 0-1.04 5.434"
      clipRule="evenodd"
    />
    <path d="M20.667 5.999a1 1 0 1 0 0 2H24a1 1 0 1 0 0-2z" />
    <path d="M19.667 12.33a1 1 0 0 1 1-1H24a1 1 0 1 1 0 2h-3.333a1 1 0 0 1-1-1" />
    <path d="M20.667 16.662a1 1 0 1 0 0 2H24a1 1 0 1 0 0-2z" />
    <path d="M19.667 9.664a1 1 0 0 1 1-1h2a1 1 0 1 1 0 2h-2a1 1 0 0 1-1-1" />
    <path d="M20.667 13.996a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2z" />
  </svg>
);
const ForwardRef = forwardRef(IconHeatOutlineSVG);
ForwardRef.displayName = "IconHeatOutline";
export { ForwardRef as IconHeatOutline };
